import React from "react";
import _ from "lodash";
import Colors from "../../constants/AppColors";

function CalloutLabel(props) {
  let style = {};

  _.merge(style, _.get(props, "style", {}));

  let hangingArrow = {
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "5px 5px 0 5px",
    borderColor: Colors.BORDER + " transparent transparent transparent",
    marginLeft: 4,
    marginTop: -1,
  };

  let labelStyle = {
    backgroundColor: Colors.BORDER,
    minWidth: 10,
    borderRadius: 4,
    color: Colors.PRIMARY_TEXT,
  };

  return (
    <div style={style}>
      <div style={labelStyle}>{props.children}</div>
      <div style={hangingArrow}></div>
    </div>
  );
}

export default CalloutLabel;
